import React from 'react'

// The caller's At Apartment procurement capabilities (from
// /alfred/apartment/my-role). Buttons render off this; the backend enforces
// regardless. Own module so the tab files and index.js don't import-cycle.
export const RoleContext = React.createContext({
  roles: [],
  can_request: false,
  is_central: false,
  is_hq: false
})

// DOM node beside the tab strip — tabs render their action buttons into it
// (portal) so actions share the tabs' line instead of taking their own row.
export const HeaderSlotContext = React.createContext(null)
